module.exports = __webpack_public_path__ + "assets/img/nanmei.642940b5.png";